import React, { useState } from "react";
import { Button, Box } from "@material-ui/core";
import SyncIcon from "@material-ui/icons/Sync";
import { makeStyles } from "@material-ui/core/styles";
import { useNotify, useRecordContext, useRefresh } from "react-admin";
import { client } from "data/gqlClient";
import { SYNC_REVENUECAT_SUBSCRIPTION } from "data/users/schema";
import { colors } from "lib/constants/colors";
import { User } from "types/graphql";
import { ViewInRevenueCatButton } from "./ViewInRevenueCatButton";

const useStyles = makeStyles({
  button: {
    backgroundColor: colors.canaryYellow[5],
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: colors.canaryYellow[6],
    },
    "&:disabled": {
      backgroundColor: colors.gray[3],
      color: "#FFFFFF",
      opacity: 0.7,
      cursor: "not-allowed",
    },
  },
  buttonContainer: {
    display: "flex",
    gap: "8px",
    marginBottom: "16px",
  },
});

export const SyncRevenueCatButton: React.FC = () => {
  const classes = useStyles();
  const record = useRecordContext<User>();
  const notify = useNotify();
  const refresh = useRefresh();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  if (record?.primarySubscription?.provider?.name !== "revenuecat") {
    return null;
  }

  const handleSync = async (): Promise<void> => {
    setIsLoading(true);
    try {
      await client.mutate(SYNC_REVENUECAT_SUBSCRIPTION, {
        uid: record.uid,
      });

      notify("Subscription synced successfully", "success");
      refresh();
    } catch (error) {
      notify("Error syncing subscription", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box className={classes.buttonContainer}>
      <Button
        onClick={handleSync}
        startIcon={<SyncIcon />}
        size="small"
        className={classes.button}
        disabled={isLoading}
      >
        {isLoading ? "Syncing..." : "Sync RevenueCat"}
      </Button>
      <ViewInRevenueCatButton />
    </Box>
  );
};
